
import { HashtagInput } from "@/components/HashtagInput";
import { AlertCircle } from "lucide-react";

interface ProfileInterestsProps {
  publicInterests: string[];
  onPublicInterestsChange: (interests: string[]) => void;
  privateInterests: string[];
  onPrivateInterestsChange: (interests: string[]) => void;
  loading: boolean;
}

export const ProfileInterests = ({
  publicInterests,
  onPublicInterestsChange,
  privateInterests,
  onPrivateInterestsChange,
  loading
}: ProfileInterestsProps) => {
  return (
    <>
      <div>
        <label className="block text-sm font-medium text-ice-white mb-2">
          Public Hashtags
        </label>
        <p className="text-sm text-ice-white/70 mb-3">
          visible in the profile
        </p>
        <HashtagInput
          hashtags={publicInterests}
          onHashtagsChange={onPublicInterestsChange}
          maxHashtags={10}
          placeholder="Add public interests (e.g., travel, music, fitness...)"
          disabled={loading}
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-ice-white mb-2">
          Private Matching Interests *
        </label>
        <p className="text-sm text-ice-white/70 mb-3">
          Add at least 5 private interests for our matching algorithm. These are used only for finding compatible matches and won't be shown on your public profile.
        </p>
        <HashtagInput
          hashtags={privateInterests}
          onHashtagsChange={onPrivateInterestsChange}
          maxHashtags={15}
          placeholder="Add private matching interests - minimum 5 required"
          disabled={loading}
        />
        {privateInterests.length < 5 && (
          <div className="flex items-center gap-2 mt-2 text-electric-violet">
            <AlertCircle className="w-4 h-4" />
            <span className="text-sm">
              You need {5 - privateInterests.length} more private interest{5 - privateInterests.length !== 1 ? 's' : ''} for matching
            </span>
          </div>
        )}
      </div>
    </>
  );
};
